<template>
  <div>
   <el-dialog
       title="提示"
       :visible.sync="dialogVisible"
       width="350px"
       append-to-body
       >
       <div class="dialog-content">
         <!-- 过滤数据 -->
         <div>
           <span v-for="item in receivableIds" :key="item">应收id{{ item }}，</span>
           <span>有正在审批中的应收调整或应收减免审批，请在审批完成后再进行调整</span>
         </div >
       </div>
       <span slot="footer" class="dialog-footer">
         <el-button @click="dialogVisible = false">取消</el-button>
         <!-- tableData.length==receivableIds.length -->
         <el-button v-if="isSubmitOther" :disabled="isDisabled" :loading="submitLoading" type="primary" @click="submitOtherData">提交其他应收</el-button>
         <el-button v-else  type="primary" @click="handleClose">{{ controlBtnName }}</el-button>
       </span>
     </el-dialog>
  </div>
 </template>

<script>
export default {
  name: 'SubmitOtherDialog',
  components: {
  },
  props: {
    receivableIds: {
      type: Array,
      default: () => [],
    },
    controlBtnName: {
      type: String,
      default: '我知道了',
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    isSubmitOther: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
    }
  },
  computed: {
    isDisabled() {
      const arr = Array.from(new Set([...this.receivableIds]))
      if (this.tableData.length <= arr.length) {
        return true
      } else {
        return false
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) this.submitLoading = false
    },
  },
  methods: {
    // 提交其他数据
    submitOtherData() {
      if (this.submitLoading) return
      this.submitLoading = true
      this.$emit('submitOtherData')
      this.dialogVisible = false
    },
    handleClose() {
      this.dialogVisible = false
    },
  },
}
</script>

 <style scoped lang='scss'>
 .dialog-content{
   padding: 10px;
   padding-bottom: 30px;
 }

 </style>

